import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider } from "@/context/AuthContext";
import { PwaUpdater } from "@/PwaUpdater";
import App from "./App";
import { pingAppwriteOnce } from "@/lib/appwrite";
// Fontsource: Inter + Lora. Imported via JS (not CSS @import) since the
// Tailwind v4 PostCSS plugin bundles CSS imports itself without rebasing
// fontsource's url(./files/*.woff2) refs — fonts 404'd otherwise. Order
// preserved: fonts load before globals.css, exactly like the v3 build.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/lora/500.css";
import "@fontsource/lora/600.css";
import "@fontsource/lora/700.css";
import "@/globals.css";

// App-start connectivity check: pings Appwrite once (unauthenticated
// GET {endpoint}/ping) so the user can confirm the SDK setup from the
// browser console. Never blocks rendering.
void pingAppwriteOnce();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <PwaUpdater />
          <App />
          <Toaster position="bottom-left" />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
